﻿// Import styles
import '../styles.css';

// Import feature modules
import './modules/navigation.js';
import './modules/faq.js';
import './modules/pricing.js';
import './modules/pricing-toggle.js';
import './modules/services.js';
import { initMagicBoostGlow } from './modules/magic-boost-glow.js';

// Show body once styles are loaded to prevent FOUC
document.body.classList.add('styles-loaded');

// Initialize Magic Boost glow effect
document.addEventListener('DOMContentLoaded', () => {
    initMagicBoostGlow();
});






